import type { FC } from 'react'
import { useState } from 'react'

import VerifyButton from '@/components/VerifyButton'
import type { CompanyDetails } from '@/types/Activity'

import VerifyOrganisationSidebar from './Sidebar'

interface Props {
  customerId: string
  subjectId: string
  company: CompanyDetails
}

const VerifyOrganisation: FC<Props> = ({ customerId, subjectId, company }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false)

  return (
    <>
      {isSidebarOpen && (
        <VerifyOrganisationSidebar
          customerId={customerId}
          subjectId={subjectId}
          company={company}
          onClose={() => setIsSidebarOpen(false)}
        />
      )}
      <VerifyButton onClick={() => setIsSidebarOpen(true)} />
    </>
  )
}

export default VerifyOrganisation
